export default "__VITE_ASSET__DxLoZQXW__"